import { default as axios } from './http';


class OBHWorksAPI {

    getOBHWorks = async () => {
      // Fetch tarps from API
      console.log('Fetching obh-works from API...')
      const url = '/api/v1/obhm/obh-works/';
      const response = await axios.get(url)
      return response
    }

    createOBHWorks = async (data) => {
      // Create tarping works in API
      const url = '/api/v1/obhm/obh-works/';
      const options = {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          }
      }
      const response = await axios.post(url, data, options)
      return response
    }

}

export default OBHWorksAPI;